import { Box, Avatar, Typography } from "@mui/material";

const PaymentSection = ({
  route,
  paymentOptionsList,
  defaultPgName,
  SetpaymentGatewayId,
  gotoHistory,
  LinkBpFun,
  DaalchiniWallet,
  Bp,
  nextArrow,
}) => {

  // 🔹 hide section for these routes
  const baseRoute = route?.split("/")?.[0]; // "taghistory"

  const hidePaymentSection = ["dphistory", "taghistory"].includes(baseRoute);

  if (hidePaymentSection) return null;

  return (
    <>
      {/* ================= DAALCHINI WALLET ================= */}
      <Box
        sx={{
          width: "100%",
          boxShadow:
            paymentOptionsList?.[3]?.pgName === defaultPgName
              ? "0px 4px 10.4px 1px rgba(0, 177, 119, 0.23)"
              : "none",
          borderRadius: "15px",
          mb: 1,
        }}
      >
        <Box
          onClick={(e) =>
            SetpaymentGatewayId(
              e,
              paymentOptionsList[3].pgId,
              paymentOptionsList?.[3]?.pgName,
              "WALLET_LOYALTY"
            )
          }
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border:
              defaultPgName === "WALLET_LOYALTY"
                ? "1px solid rgba(0, 177, 119, 0.5)"
                : "none",
            borderRadius: "15px",
            p: 1,
            cursor: "pointer",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", width: "96%" }}>
          
             <img  src={DaalchiniWallet || ""}style={{width:"32px",height:"27px"}}/>
            <Box sx={{ ml: 1 }}>
              <Typography sx={{ fontSize: 16, fontWeight: 500 }} color={"#333F4E"}>
                Daalchini
              </Typography>
              <Typography sx={{ fontSize: 13, color: "#718198" }}>
                Balance ₹{paymentOptionsList?.[3]?.balance}
              </Typography>
            </Box>
          </Box>

          <Box
            onClick={(e) => {
              e.stopPropagation();
              gotoHistory();
            }}
          >
            <Avatar
              src={nextArrow}
              sx={{ width: 10, height: 16, bgcolor: "transparent" }}
            />
          </Box>
        </Box>
      </Box>

      {/* ================= BUSINESS PAYMENTS ================= */}
      {paymentOptionsList?.[2]?.active === true ? (
        <Box
          onClick={(e) =>
            SetpaymentGatewayId(
              e,
              paymentOptionsList[2].pgId,
              paymentOptionsList?.[2]?.pgName,
              "WALLET_"
            )
          }
          sx={{
            width: "100%",
            boxShadow:
              paymentOptionsList?.[2]?.pgName === defaultPgName
                ? "0px 4px 10.4px 1px rgba(0, 177, 119, 0.23)"
                : "none",
            borderRadius: "15px",
            mb: 1,
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border:
                defaultPgName === "WALLET"
                  ? "1px solid rgba(0, 177, 119, 0.5)"
                  : "none",
              borderRadius: "15px",
              p: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", width: "96%",borderRadius:"0px" }}  style={{borderRadius:"0px"}}>
            <img src={Bp || ""} style={{width:"32px",height:"27px"}}/>
              <Box sx={{ ml: 1 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 500 }} color={"#333F4E"}>
                  Business Payments
                </Typography>
                {paymentOptionsList[2]?.reason !== "BALANCE_REDACTED" && (
                  <Typography sx={{ fontSize: 13, color: "#718198" }}>
                    Balance ₹{paymentOptionsList[2]?.balance}
                  </Typography>
                )}
              </Box>
            </Box>

            <a href="/bphistory">
              <Avatar
                src={nextArrow}
                sx={{ width: 10, height: 16, bgcolor: "transparent" }}
              />
            </a>
          </Box>
        </Box>
      ) : paymentOptionsList?.[2]?.reason === "NOT_LINKED" ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
            mb: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img src={Bp || ""} style={{width:"32px",height:"27px"}}/>
            <Box sx={{ ml: 1 }}>
              <Typography fontWeight={500} color={"#333F4E"}>Business Payments</Typography>
              <Typography fontSize={13} color="#718198">
                business payment accounts
              </Typography>
            </Box>
          </Box>

          <button
            onClick={LinkBpFun}
            style={{
              background: "none",
              border: "none",
              color: "#00B177",
              cursor: "pointer",
            }}
          >
            Link
          </button>
        </Box>
      ) : (


    

                <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
            mb: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
              <img src={Bp || ""} style={{width:"32px",height:"27px"}}/>
            <Box sx={{ ml: 1 }}>
              <Typography fontWeight={500} color={"#333F4E"}>Business Payments</Typography>
                 <Typography color="red">
            {paymentOptionsList?.[2]?.reason}
          </Typography>
            </Box>
          </Box>

        
      
        </Box>
      )}
    </>
  );
};

export default PaymentSection;
